// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"file-markdown"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M20 22V8H14V2H4V22H20Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M14 2V8H20M20 7V22H4V2H15L20 7Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M9 17V12H12M12 12L12 17M12 12H14C14.5523 12 15 12.4477 15 13V17","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const FileMarkdownIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'file-markdown',
    ref,
    icon: element,
  },
));

FileMarkdownIcon.displayName = 'FileMarkdownIcon';

export default FileMarkdownIcon;
